import React from "react";
import CrudModule, { StatusBadge } from "@/components/CrudModule";
import { fmtDate } from "@/lib/api";

export default function Safety() {
  return (
    <CrudModule
      title="Safety & Compliance"
      subtitle="Inspections, pressure tests, OSHA records & compliance calendar."
      endpoint="safety"
      testid="safety"
      columns={[
        { key: "type", label: "Inspection / Test" },
        { key: "target", label: "Target" },
        { key: "status", label: "Status", render: (v) => <StatusBadge value={v} /> },
        { key: "last_done", label: "Last Done", render: (v) => fmtDate(v) },
        { key: "due_date", label: "Due Date", render: (v) => fmtDate(v) },
      ]}
      fields={[
        { key: "type", label: "Inspection / Test Type", full: true },
        { key: "target", label: "Target (asset/location)" },
        { key: "status", label: "Status", type: "select", options: ["ok", "due", "overdue"] },
        { key: "last_done", label: "Last Done", type: "date" },
        { key: "due_date", label: "Due Date", type: "date" },
      ]}
    />
  );
}
